import ModalComponent from '../../ModalComponent';

interface Props {
  open: boolean
  handleClose: () => void
  handleSave: () => void
  title: string
  desc: string
}

const Index = (props:Props) => {
  const {
    open, handleClose, handleSave, title, desc,
  } = props;

  return (
    <ModalComponent
      title={title}
      confirmButtonText="削除"
      confirmButtonColor="danger"
      onConfirm={handleSave}
      show={open}
      closeModal={handleClose}
      centered
      animation={false}
    >
      <p className="mb-0">{desc}</p>
    </ModalComponent>
  );
};

export default Index;
